import React, { useState } from "react";
import { Box, ExpandableCard, Heading, Text } from "@telia/teddy";
import { RDSubscription } from "../../../../../../models";
import SubscriptionTerms from "../../../../components/components/molecules/SubscriptionTerms/SubscriptionTerms";
import SubscriptionTextBlock from "../../../../components/components/molecules/SubscriptionTextBlock/SubscriptionTextBlock";

const SubscriptionInfo: React.FC<{ subscription: RDSubscription }> = ({ subscription }) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasMoreInfo = !!(subscription.dataMaxSpeed || subscription.textBlocks?.length || subscription.disclaimer);
    const isPrepaid = subscription.offeringCode?.startsWith("KONTANT");

    return (
        <Box mb="400">
            <ExpandableCard
                type="single"
                collapsible
                value={isOpen ? "info" : ""}
                onValueChange={(value) => setIsOpen(value === "info")}
            >
                <ExpandableCard.Item value="info">
                    <ExpandableCard.Trigger>
                        <Box mb="200">
                            <ExpandableCard.Header>
                                <ExpandableCard.Description>
                                    <Heading mb="100" as="h2" variant="title-100">
                                        Priser
                                    </Heading>
                                </ExpandableCard.Description>
                                {hasMoreInfo && <ExpandableCard.Indicator />}
                            </ExpandableCard.Header>
                        </Box>
                        {((subscription.firstYearDiscountAmount ?? 0) > 0 ||
                            (subscription.monthlyDiscount ?? 0) > 0) && (
                            <>
                                <Text>
                                    <strong>Kampanjepriser</strong>
                                </Text>
                                <Text>
                                    Pris:{" "}
                                    {subscription.monthlyPrice -
                                        (subscription.firstYearDiscountAmount ?? 0) -
                                        (subscription.monthlyDiscount ?? 0)}
                                    ,-/md
                                </Text>
                                {!!subscription.monthlyPriceLines &&
                                    subscription.monthlyPriceLines < subscription.monthlyPrice && (
                                        <Text>
                                            Pris med familierabatt:{" "}
                                            {subscription.monthlyPriceLines -
                                                (subscription.firstYearDiscountAmount ?? 0) -
                                                (subscription.monthlyDiscount ?? 0)}
                                            ,-/md
                                        </Text>
                                    )}
                                <Text mt="200">
                                    <strong>Ordinære priser</strong>
                                </Text>
                            </>
                        )}
                        {!!subscription.upfrontPrice && <Text>Pris: {subscription.upfrontPrice}</Text>}
                        {!!subscription.monthlyPrice && <Text>Pris: {subscription.monthlyPrice},-/md</Text>}
                        {!!subscription.monthlyPriceLines &&
                            subscription.monthlyPriceLines < subscription.monthlyPrice && (
                                <Text>Pris med familierabatt: {subscription.monthlyPriceLines},-/md</Text>
                            )}
                        {isPrepaid && (
                            <Text mt="200">
                                Fri tale, SMS og MMS er inkludert sammen med 250 MB data i 14 dager. Deretter må du
                                fylle på for å bruke telefonen videre. Etter at forhåndtbetalte datakvoter er brukt
                                koster data kr 10 per MB, makspris per dag kr 10 for inntil 100MB. Når saldo og kvoter
                                er tomme vil det være blokkert for datatrafikk, men man kan kjøpe flere datapakker.
                            </Text>
                        )}
                    </ExpandableCard.Trigger>
                    {hasMoreInfo && (
                        <ExpandableCard.Content>
                            {subscription.dataMaxSpeed && (
                                <Box mb="200">
                                    <Heading as="h2" variant="title-100" mb="50">
                                        Hastighet
                                    </Heading>
                                    <Text>
                                        Max Hastighet: {subscription.dataMaxSpeed.amount}{" "}
                                        {subscription.dataMaxSpeed.unit}
                                    </Text>
                                </Box>
                            )}
                            {subscription.textBlocks?.map((textBlock) => (
                                <SubscriptionTextBlock
                                    headingSize="xs"
                                    headingTag="h3"
                                    key={textBlock.heading}
                                    textBlock={textBlock}
                                    subscriptionSpeed={subscription.dataMaxSpeed}
                                />
                            ))}
                            {subscription.disclaimer && <SubscriptionTerms content={subscription.disclaimer} />}
                        </ExpandableCard.Content>
                    )}
                </ExpandableCard.Item>
            </ExpandableCard>
        </Box>
    );
};

export default SubscriptionInfo;
